module.exports = __webpack_public_path__ + "media/images/img_about_03-3d21784e8ea4344a9ba996608956f01d.png";